import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from 'components/ui/use-toast';
import * as Api from '../api';

// Revokes the team's join link + code (disables joining until regenerated).
const useRevokeJoinToken = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (teamId: string) => {
      await Api.revokeJoinToken(teamId);
      return teamId;
    },
    onSuccess: (teamId) => {
      queryClient.invalidateQueries({ queryKey: ['teams', 'join-token', teamId] });
    },
    onError: (error: any) => {
      toast.error('Error', {
        description: error?.response?.data?.message || 'Failed to revoke join link',
      });
    },
  });
};

export default useRevokeJoinToken;
